var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !["AccountMembers", "AccountGroups"].includes(_vm.$route.name)
    ? _c(
        "div",
        [
          _c("v-skeleton-loader", {
            staticClass: "rounded-t-md",
            attrs: { transition: "fade-transition", type: "table-thead" },
          }),
          _c("v-skeleton-loader", {
            staticClass: "rounded-b-md",
            attrs: { transition: "fade-transition", type: "table-tbody" },
          }),
        ],
        1
      )
    : _c(
        "v-col",
        { staticClass: "pa-0", attrs: { cols: "12" } },
        [
          _c(
            "v-row",
            _vm._l(5, function (action) {
              return _c(
                "v-col",
                {
                  key: action,
                  attrs: {
                    cols: "4",
                    md: _vm.$vuetify.breakpoint.width < 1200 ? 3 : 2,
                  },
                },
                [
                  _c("v-skeleton-loader", {
                    staticClass: "rounded-md",
                    attrs: { height: "110", type: "image" },
                  }),
                ],
                1
              )
            }),
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "2" } },
                [
                  _c("v-skeleton-loader", {
                    staticClass: "rounded-md",
                    attrs: { type: "text" },
                  }),
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-col",
                { staticClass: "mr-10", attrs: { cols: "1" } },
                [
                  _c("v-skeleton-loader", {
                    staticClass: "rounded-md",
                    attrs: { type: "text" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }